// components/sidebar/index.jsx
import React, { useContext, useEffect, useMemo, useCallback, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
	Box,
	Drawer,
	// CssBaseline,
	AppBar as MuiAppBar,
	Toolbar,
	List,
	Typography,
	Divider,
	IconButton,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Collapse,
	Tooltip,
	Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBoxesPacking,
	faUserTie,
	faUsers,
	faChartBar,
	faChartPie,
	faUser,
	faCoins,
	faUserFriends,
	faBullhorn,
	faRobot,
	faClock,
	faCog,
	faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";
import "./style.css";
import ModalSideBar from "./modal";
import SideRight from "./side-right";
import { ProviderContracting } from "../../pages/contratacao/context";
import MainContracting from "../../pages/contratacao/register-contracting/Main";
import { ContextGlobal } from "../../context";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import reqColaborador from "../../services/reqMultiTenant/reqColaborador";
import { clearSessionAndRedirectLogin } from "../../util/libLocalStorage";

const drawerWidth = 300;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
	flexGrow: 1,
	padding: theme.spacing(3),
	transition: theme.transitions.create("margin", {
		easing: "cubic-bezier(0.4, 0, 0.6, 1)", // sharp
		duration: theme.transitions.duration.leavingScreen,
	}),
	marginLeft: `-${drawerWidth}px`,
	overflowX: "auto",
	...(open && {
		transition: theme.transitions.create("margin", {
			easing: "cubic-bezier(0.0, 0, 0.2, 1)", // easeOut
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 0,
	}),
}));

const AppBar = styled(MuiAppBar, {
	shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
	transition: theme.transitions.create(["margin", "width"], {
		easing: "cubic-bezier(0.4, 0, 0.6, 1)", // sharp
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: `${drawerWidth}px`,
		transition: theme.transitions.create(["margin", "width"], {
			easing: "cubic-bezier(0.0, 0, 0.2, 1)", // easeOut
			duration: theme.transitions.duration.enteringScreen,
		}),
	}),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	padding: theme.spacing(0, 1),
	...theme.mixins.toolbar,
	justifyContent: "flex-end",
	position: "sticky", // <— fixa no topo ao rolar
	top: 0,
	zIndex: 1,
	backgroundColor: theme.palette.background.paper,
	borderBottom: `1px solid ${theme.palette.divider}`,
}));

// const DrawerHeader = styled("div")(({ theme }) => ({
// 	display: "flex",
// 	alignItems: "center",
// 	padding: theme.spacing(0, 1),
// 	...theme.mixins.toolbar,
// 	justifyContent: "flex-end",
// }));

/** =======================
 *  MENU (config estática)
 *  ======================= */
const MENU = [
	{
		section: "CADASTRO",
		groups: [
			{
				key: "empresa",
				icon: faUserTie,
				label: "Minha Empresa",
				required: [],
				links: [{ to: "/register-store", label: "Cadastro da empresa" }],
			},
			{
				key: "clientes",
				icon: faUsers,
				label: "Clientes",
				required: ["PDV", "CATÁLOGO", "WHATSAPP", "CONVERSACAO"],
				links: [
					{ to: "/register-client", label: "Cadastro de clientes" },
					{ to: "/client-type", label: "Cadastro tipo de cliente" },
				],
			},
			{
				key: "colaborador",
				icon: faUserFriends,
				label: "Colaborador",
				required: ["PDV", "CATÁLOGO", "WHATSAPP", "CONVERSACAO"],
				links: [
					{ to: "/register-colaborador", label: "Cadastro Colaborador" },
					{ to: "/collaborator-type", label: "Cadastro tipo de colaborador" },
				],
			},
			{
				key: "produtos",
				icon: faBoxesPacking,
				label: "Produto",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/register-product", label: "Cadastro Produto" },
					{ to: "/register-complements", label: "Cadastro Complemento" },
					{ to: "/register-category", label: "Cadastro Categoria" },
				],
			},
			{
				key: "whatsapp",
				icon: faRobot,
				label: "WA Connect",
				required: ["WHATSAPP", "CONVERSACAO"],
				links: [
					{ to: "/whatsapp-connect", label: "Conexão WhatsApp" },
					{ to: "/whatsapp-sender", label: "Mensagens em Massa" },
					// { to: "/whatsapp-dashboard", label: "Dashboard" },
					// { to: "/reports/leads/whatsapp", label: "Relatórios de Leads" },
				],
			},
			{
				key: "whatsapp-oficial",
				icon: faRobot,
				label: "WA Oficial",
				required: ["WHATSAPP OFICIAL"],
				links: [
					{ to: "/whatsapp-oficial", label: "Mensagens Api Oficial" },
					{ to: "/whatsapp-oficial-v2", label: "Mensagens Api Oficial V2" },
				],
			},
			{
				key: "instagram",
				icon: faInstagram,
				label: "Instagram",
				required: ["WHATSAPP", "CONVERSACAO"],
				links: [
					{ to: "/instagram-register", label: "Conexão Instagram" },
					{ to: "/instagram-posts", label: "Automatizar Posts" },
					{ to: "/instagram-dm", label: "Automatizar DM" },
				],
			},
			{
				key: "vendas_online",
				icon: faBullhorn,
				label: "Vendas Online",
				required: ["CATÁLOGO"],
				links: [
					{ to: "/register-promotions", label: "Cupons de Desconto" },
					{ to: "/register-banners", label: "Banners do Catálogo" },
					{ to: "/store-logo", label: "Logo da Empresa" },
					{ to: "/store-catalog", label: "Configuração do Catálogo" },
				],
			},
			{
				key: "funcionamento",
				icon: faClock,
				label: "Funcionamento",
				required: ["CATÁLOGO"],
				links: [
					{ to: "/store-hours", label: "Horários de Funcionamento" },
					{ to: "/scheduled-pauses", label: "Pausas Programadas" },
					{ to: "/delivery-fee", label: "Taxas de Entrega" },
				],
			},
			{
				key: "fornecedor",
				icon: faUser,
				label: "Fornecedor",
				required: ["CATÁLOGO", "PDV"],
				links: [{ to: "/register-fornecedor", label: "Cadastro Fornecedor" }],
			},
			{
				key: "pagamento",
				icon: faCoins,
				label: "Financeiro",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/forma-pagamento", label: "Forma de Pagamento" },
					{ to: "/register-cost-center", label: "Departamento de Custo" },
					{ to: "/type-account", label: "Conta Tipo" },
					{ to: "/bank", label: "Banco" },
				],
			},
		],
	},
	{
		section: "RECEITAS E DESPESAS",
		groups: [
			{
				key: "receitasedespesas",
				icon: faCoins,
				label: "Receitas e Despesas",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/conta-entrada", label: "Receitas" },
					{ to: "/conta-saida", label: "Despesas" },
				],
			},
			{
				key: "boletos",
				icon: faFileInvoiceDollar,
				label: "Boletos",
				required: ["BOLETO"],
				links: [
					{ to: "/boleto-config", label: "Convênio de Boleto" },
					{ to: "/boleto/remessa", label: "Remessa" },
					{ to: "/boleto/retorno", label: "Retorno" },
				],
			},
		],
	},
	{
		section: "FISCAL",
		groups: [
			{
				key: "configuracao-fiscal",
				icon: faCog,
				label: "Configuração Fiscal",
				required: ["EMISSOR FISCAL"],
				links: [
					{ to: "/fiscal-config", label: "Configuração" },
				],
			},
			{
				key: "documentos-fiscais",
				icon: faFileInvoiceDollar,
				label: "Documentos Fiscais",
				required: ["EMISSOR FISCAL"],
				links: [
					{ to: "/fiscal/monitor", label: "Monitor Fiscal" },
					{ to: "/fiscal/documentos", label: "Documentos" },
					{ to: "/fiscal/sefaz", label: "Consulta na SEFAZ" },
					{ to: "/fiscal/fechamento", label: "Fechamento (Contabilidade)" },
				],
			},
		],
	},
	{
		section: "RELATÓRIOS",
		groups: [
			{
				key: "movimentacao",
				icon: faChartBar,
				label: "Movimentação",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/movimentacao", label: "Caixa" },
					{ to: "/movimentacao-financeira", label: "Movimentação Financeira" },
				],
			},
			{
				key: "produtos-rel",
				icon: faBoxesPacking,
				label: "Produto",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/produtos-deletados", label: "Produtos Deletados" },
					{ to: "/produtos/vendas/estoque", label: "Produtos Vendidos" },
					{ to: "/produtos/curva-abc", label: "Curva ABC" },
					{ to: "/produtos/estoque-baixo", label: "Estoque Baixo" },
					{ to: "/produtos/item-faturamento", label: "Produto Faturamento" },
				],
			},
			{
				key: "produtos-grade-rel",
				icon: faBoxesPacking,
				label: "Produto Grade",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/produtos/grade-vendidos", label: "Grade Vendidos" },
					{ to: "/produtos/estoque-baixo-grade", label: "Estoque Baixo Grade" },
				],
			},
			{
				key: "clientes-rel",
				icon: faUsers,
				label: "Clientes",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/cliente/vendas/tipo", label: "Receitas por tipo de Cliente" },
					{ to: "/cliente/ranking", label: "Ranking de Clientes" },
					{ to: "/cliente/inativos", label: "Clientes Inativos" },
				],
			},
			{
				key: "funcionarios-rel",
				icon: faUsers,
				label: "Colaboradores",
				required: ["CATÁLOGO", "PDV"],
				links: [{ to: "/vendas-colaborador", label: "Vendas por Colaborador" }],
			},
			{
				key: "dashboard",
				icon: faChartPie,
				label: "Vendas",
				required: ["CATÁLOGO", "PDV"],
				links: [
					{ to: "/dashboard-vendas", label: "Resumo Anual" },
					{ to: "/vendas-detalhamento", label: "Detalhamento por período" },
					{ to: "/vendas/listagem", label: "Listagem de Vendas" },
					{ to: "/dashboard-receitas-e-despesas", label: "Receitas vs Despesas" },
				],
			},
		],
	},
	{
		section: "Fatura",
		visibleIf: ({ demoList }) => demoList.length === 0,
		groups: [
			{
				key: "fatura",
				icon: faChartPie,
				label: "Fatura",
				required: [],
				links: [{ to: "/invoice-viewer", label: "Minha Fatura" }],
			},
		],
	},
	{
		section: "ADMINISTRAÇÃO",
		visibleIf: ({ idEmpresa }) => idEmpresa === 1,
		groups: [
			{
				key: "admin",
				icon: faCog,
				label: "Configurações Globais",
				required: [],
				links: [
					{ to: "/server/status", label: "Status do Servidor" },
					{ to: "/admin/credenciais", label: "Credenciais de API" },
				],
			},
		],
	},
];

/** Item de menu “puro”, evita re-render se props não mudarem */
const MenuGroup = React.memo(function MenuGroup({ icon, text, submenuKey, open, onToggle, links, onLinkClick }) {
	return (
		<>
			<ListItem key={text} disablePadding className="color-blue">
				<ListItemButton onClick={() => onToggle(submenuKey)}>
					<ListItemIcon>{icon && <FontAwesomeIcon icon={icon} className="color-blue" />}</ListItemIcon>
					<ListItemText primary={text} />
					{open ? <ExpandLess /> : <ExpandMore />}
				</ListItemButton>
			</ListItem>
			<Collapse in={open} timeout="auto" unmountOnExit className="subitem">
				<List component="div" disablePadding>
					{links.map(({ to, label }) => (
						<ListItem key={label} disablePadding>
							<ListItemButton onClick={onLinkClick} component={Link} to={to}>
								<span className="large-font">{label}</span>
							</ListItemButton>
						</ListItem>
					))}
				</List>
			</Collapse>
		</>
	);
});

const SideBar = (props) => {
	// const theme = useTheme();
	const [open, setOpen] = useState(false);
	const [empresaName, setEmpresaName] = useState("");
	const [subMenuStates, setSubMenuStates] = useState({});

	//somente o grupo que pode ficar aberto
	const [openSubmenu, setOpenSubmenu] = useState(null);

	//modulos permitidos vem do context que e usa um join na tabela tipo_produto
	const { modulopermitted, listPermissionsData } = useContext(ContextGlobal);

	// carrega nome da empresa uma vez
	useEffect(() => {
		const storedEmpresaName = listPermissionsData?.nome_empresa;
		if (storedEmpresaName) setEmpresaName(storedEmpresaName);
	}, [listPermissionsData]);

	// não duplicar state (evitar usar useState pra guardar algo que já vem de outro lugar).
	const appsPermitidos = useMemo(() => modulopermitted || [], [modulopermitted]);

	// set de apps permitidos (filtra status)
	const allowedSet = useMemo(() => {
		return new Set(
			appsPermitidos
				.filter((i) => i.status === "ATIVO" || i.status === "DEMO" || i.status === "FREE")
				.map((i) => i.modulo),
		);
	}, [appsPermitidos]);

	// verifica se é versão de teste, para mostrar tarja no topo do appbar e botão de contratar
	const demoList = useMemo(
		() => appsPermitidos.filter((i) => i.status === "DEMO" || i.status === "DEMO_EXPIRADO"),
		[appsPermitidos],
	);

	//validar se o usuário tem permissão em algum módulo.
	const hasPermission = useCallback(
		(...required) => {
			if (!required || required.length === 0) return true;
			return required.some((app) => allowedSet.has(app));
		},
		[allowedSet],
	);

	// filtra o MENU de acordo com as permissões, memoizado
	const visibleMenu = useMemo(() => {
		const idEmpresa = listPermissionsData?.id_empresa;
		return (
			MENU
				// filtra seção pela função visibleIf
				.filter((sec) => {
					if (typeof sec.visibleIf === "function") {
						return sec.visibleIf({ demoList, allowedSet, idEmpresa });
					}
					return true; // padrão: visível
				})
				// filtra grupos pela permissão
				.map((sec) => ({
					...sec,
					groups: sec.groups.filter((g) => hasPermission(...g.required)),
				}))
				// só mostra seção se tiver grupos
				.filter((sec) => sec.groups.length > 0)
		);
	}, [hasPermission, demoList, allowedSet]);

	// const visibleMenu = useMemo(() => {
	// 	return MENU.map((sec) => ({
	// 		...sec,
	// 		groups: sec.groups.filter((g) => hasPermission(...g.required)),
	// 	})).filter((sec) => sec.groups.length > 0);
	// }, [hasPermission]);

	// callbacks estáveis (não mudam a cada render)
	const handleDrawerOpen = useCallback(() => setOpen(true), []);
	const handleDrawerClose = useCallback(() => setOpen(false), []);
	const handleSubMenuToggle = useCallback((submenu) => {
		setOpenSubmenu((prev) => (prev === submenu ? null : submenu));
		// setSubMenuStates((prev) => ({ ...prev, [submenu]: !prev[submenu] }));
	}, []);
	const handleExit = useCallback(async () => {
		await reqColaborador.logout().catch(() => {});
		clearSessionAndRedirectLogin();
	}, []);
	const handleOpenModal = useCallback(() => {
		window.dispatchEvent(new CustomEvent("StoreConfirmation"));
	}, []);
	const handleLinkClick = useCallback(() => {
		// fecha o drawer ao navegar
		setOpen(false);
	}, []);

	return (
		<>
			<Box sx={{ display: "flex" }} className="mt-3">
				{/* <CssBaseline /> */}
				<AppBar position="fixed" open={open} sx={{ backgroundColor: "#3c5f97" }}>
					<Toolbar>
						<IconButton
							color="inherit"
							aria-label="open drawer"
							onClick={handleDrawerOpen}
							edge="start"
							sx={{ mr: 2, ...(open && { display: "none" }) }}
						>
							<MenuIcon />
						</IconButton>
						<Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
							{empresaName}
						</Typography>
						<SideRight handleExit={handleExit} handleDrawerClose={handleDrawerClose} />
					</Toolbar>

					{demoList.length > 0 && (
						<div
							id="tarja-demo"
							className="flex justify-between items-center bg-gradient-to-r from-red-500 to-red-600 py-2 shadow-md gap-10"
						>
							<div className="flex flex-col ms-4" />
							<div className="flex flex-col me-4">
								<button
									className="px-4 py-1 bg-white text-red-600 text-sm font-medium rounded-md shadow hover:bg-red-100 transition duration-300"
									onClick={handleOpenModal}
								>
									Clique para assinar
								</button>
								{demoList.map((item) => (
									<span
										key={item.modulo}
										className="text-xs text-white font-light italic mt-1 hidden sm:block"
									>
										{item.dias_restantes >= 0
											? `Versão de teste módulo ${item.modulo} ${item.dias_restantes} dias restantes`
											: `Versão de teste módulo ${item.modulo} 0 dias restantes`}
									</span>
								))}
							</div>
						</div>
					)}
				</AppBar>

				<Drawer
					sx={{
						width: drawerWidth,
						flexShrink: 0,
						"& .MuiDrawer-paper": {
							width: drawerWidth,
							boxSizing: "border-box",
							display: "flex",
							flexDirection: "column", // <— importante
						},
					}}
					variant="persistent"
					anchor="left"
					open={open}
				>
					<DrawerHeader>
						<Tooltip title="Recolher menu (Esc)" arrow>
							<Button
								onClick={handleDrawerClose}
								startIcon={<ChevronLeftIcon />} // ou <CloseIcon />
								variant="text"
								size="small"
								sx={{ textTransform: "none" }}
								aria-label="Recolher menu"
							>
								Recolher
							</Button>
						</Tooltip>
					</DrawerHeader>

					{/* <DrawerHeader>
						<IconButton onClick={handleDrawerClose}>
							{theme.direction === "ltr" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
						</IconButton>
					</DrawerHeader> */}

					{/* <Divider /> */}
					{/* CONTEÚDO ROLÁVEL */}
					<Box sx={{ flex: 1, overflowY: "auto" }}>
						<List className="list-menu">
							{visibleMenu.map((sec) => (
								<React.Fragment key={sec.section}>
									<Divider />
									<Typography
										variant="caption"
										sx={{ color: "gray", ml: "16px", mt: "8px", mb: "8px" }}
									>
										{sec.section}
									</Typography>

									{sec.groups.map((g) => (
										<MenuGroup
											key={g.key}
											icon={g.icon}
											text={g.label}
											submenuKey={g.key}
											open={openSubmenu === g.key}
											onToggle={handleSubMenuToggle}
											links={g.links}
											onLinkClick={handleLinkClick}
										/>
									))}
								</React.Fragment>
							))}

							{/* “Sair” não depende de permissão */}
							<Divider />
							<ListItem key="Sair" disablePadding className="color-blue">
								<ListItemButton onClick={handleExit}>
									<ListItemIcon>
										<i className="fas fa-sign-out-alt color-blue"></i>
									</ListItemIcon>
									<ListItemText primary="Sair" />
								</ListItemButton>
							</ListItem>

							{/* Versão do Sistema (Ajustar manualmente aqui) */}
							<Divider />
							<Box sx={{ p: 2, textAlign: "center", color: "text.secondary", mt: 2 }}>
								<Typography variant="caption" display="block">
									Versão: 1.0.1
								</Typography>
							</Box>
						</List>
					</Box>
				</Drawer>

				<Main open={open} sx={{ marginTop: demoList.length > 0 ? "45px" : "0" }}>
					<ModalSideBar ident="StoreConfirmation">
						<ProviderContracting>
							<MainContracting />
						</ProviderContracting>
					</ModalSideBar>
					{props.render}
				</Main>
			</Box>
			{/* )} */}
		</>
	);
};

export default React.memo(SideBar);
